import { useItemTypeLevelsQuery } from '@/lib/queries/common/useItemTypeLevelsQuery';
import { useGetJiraItemLevelMappings } from '@/lib/queries/work-integrations/useGetJiraItemLevelMappings';

export const useIsItemLevelMapped = ({
  instanceId,
  itemLevelId,
}: {
  instanceId?: string;
  itemLevelId?: number;
}): { isMapped: boolean; isLoading: boolean } => {
  const enabled = instanceId !== undefined && itemLevelId !== undefined;
  const {
    data: levels = [],
    isLoading: levelsLoading,
    isError: levelsError,
  } = useItemTypeLevelsQuery({ enabled });
  const {
    data: mappings = [],
    isLoading: mappingsLoading,
    isError: mappingsError,
  } = useGetJiraItemLevelMappings({ instanceId, enabled });

  if (!enabled) {
    return { isMapped: true, isLoading: false };
  }
  if (levelsLoading || mappingsLoading) {
    return { isMapped: true, isLoading: true };
  }
  if (levelsError || mappingsError) {
    return { isMapped: true, isLoading: false };
  }

  const level = levels.find((l) => l.id === itemLevelId)?.level;
  if (level === undefined) {
    return { isMapped: true, isLoading: false };
  }

  const isMapped = mappings.some((m) => m.itemLevel === level);
  return { isMapped, isLoading: false };
};
